import type { Router } from "expo-router";

import type { RemoteMessage } from "./messaging-service";
import { NotificationDataSchema } from "./types";

export function navigateToNotification(router: Router, message: RemoteMessage) {
  const parsed = NotificationDataSchema.safeParse(message.data);
  if (!parsed.success) return;

  const { type, tenantId, siteId, cameraKey } = parsed.data;

  if (type === "alarm_activation" && tenantId && siteId && cameraKey) {
    router.push(`/tenants/${tenantId}/sites/${siteId}/cameras/${cameraKey}` as never);
  }
}
